<template>

  <section class="padded">

    <el-row>
      <h3>Notification e-Mails for <b>this {{this.actionData.actionType}}</b></h3>
    </el-row>

    <el-alert type="info"
      title="Organisation Emails"
      :description="alertDescription"
      show-icon
      center
      :closable="false" />

    <el-row :gutter="12">
      <table class="el-table">
        <thead>
          <th><center>{{this.actionData.organisation.name}}
            <el-button v-if="(isTelco() || isSuper()) && canEditTelcoRecipients()" type="text"
              :aria-label="'Add missing ' + telcoOrgName() + ' contacts'"
              @click="updateEmails('telco', true)">
              <i class="fa fa-sync"></i>
            </el-button>
          </center>
        </th>
        <th>
          <center>{{this.xolasClient().name}}
            <el-button v-if="isTowerCo()" type="text"
              :aria-label="'Add missing ' + this.xolasClient().name + ' contacts'"
              @click="updateEmails('tower', true)">
              <i class="fa fa-sync"></i>
            </el-button>
          </center>
        </th>
      </thead>

      <!--
      <el-input v-if="isTelco()" v-model="email" type="text" size="small">
      <template #prepend><i class="fa fa-envelope"></i></template>
    </el-input>
    <span v-else>
    <b>{{email}}</b> <a v-if="email" :href="'mailto:' + email"><i class="fa fa-edit-outline"></i></a>
  </span>

-->
  <tbody>
    <tr>
      <td>
        <!-- XOL-526 (U-L): an empty per-request list now silently falls back
             to the org's own opt-ins server-side (A7) — say so, or the Tower
             Co has no way to know why an "empty" list still sends mail. -->
        <p v-if="!emails.telco || emails.telco.length === 0" class="text-muted"><small>{{emptyFallbackLine('telco')}}</small></p>
        <div v-for="(email, index) in emails.telco" :key="email.email || index">
          <el-col :span="18" :offset="2">
            <a v-if="email" :href="'mailto:' + email.email">
              <i class="fa fa-edit-outline"></i> {{email.email}}
            </a>
          </el-col>
          <el-col :span="4">
            <el-button v-if="canEditTelcoRecipients()"
            style="color: indianred;"
            :aria-label="'Remove ' + email.email"
            @click="deleteEmail(emails.telco, index)"
            type="text" size="mini">
            <i class="fa fa-times-circle"></i>
          </el-button>
        </el-col>
      </div>
    </td>
    <td>
      <p v-if="!emails.tower || emails.tower.length === 0" class="text-muted"><small>{{emptyFallbackLine('tower')}}</small></p>
      <div v-for="(email, index) in emails.tower" :key="email.email || index">
        <el-col :span="18" :offset="2">
          <a v-if="email" :href="'mailto:' + email.email">
            <i class="fa fa-edit-outline"></i> {{email.email}}
          </a>
        </el-col>
        <el-col :span="4">
          <el-button v-if="isTowerCo()"
          @click="deleteEmail(emails.tower, index)"
          :aria-label="'Remove ' + email.email"
          style="color: indianred;"
          type="text" size="mini">
          <i class="fa fa-times-circle"></i>
        </el-button>
      </el-col>
    </div>
  </td>
  </tr>

  <tr>
    <td>
      <div v-if="(isTelco() || isSuper()) && canEditTelcoRecipients()">
        <el-row>
          <el-col :span="16">
            <el-input type="email" v-model="newTelcoEmail" />
          </el-col>
          <el-col :span="4" :offset="1">
            <el-button type="primary"
            @click="addEmail('telco', newTelcoEmail)"
            :disabled="!newTelcoEmail">
            <i class="fa fa-plus"></i> Add</el-button>
          </el-col>
        </el-row>
      </div>
      <!-- XOL-535 (S6, UX §2.6.2): a Telco on RTS/RTU/RTD (D9 is RTB-only)
           sees why the controls above are gone, instead of a silently-empty
           cell. A VIEW-ONLY Telco on an RTB never reaches this render at all
           — Popup.vue disables its trigger for any view-only user
           (`:disabled="disableButton || isViewOnly()"`), so the popup itself
           never opens for them; this note is not what tells them anything. -->
      <p v-else-if="isTelco() || isSuper()" class="text-muted">
        <small>{{'Only ' + towerCoName() + ' can change this list.'}}</small>
      </p>
    </td>
    <td>
      <div v-if="isTowerCo()">
        <el-row>
          <el-col :span="16">
            <el-input type="email" v-model="newEmail" />
          </el-col>
          <el-col :span="4" :offset="1">
          <el-button type="primary"
            @click="addEmail('tower', newEmail)"
            :disabled="!newEmail">
            <i class="fa fa-plus"></i> Add</el-button>
          </el-col>
        </el-row>
      </div>
    </td>
  </tr>

  </tbody>

  <tfoot>
    <td>
      <el-col align="center">
      <el-button v-if="isTelco() || isSuper()"
      type="warning"
      icon="fa fa-envelope"
      @click="sendTest('telco')" :disabled="!isEnabled">Send Test Email</el-button>
    </el-col>
    </td>
    <td>
      <el-col align="center">
        <el-button v-if="isTowerCo()"
          type="warning"
          icon="fa fa-envelope"
          @click="sendTest('tower')" :disabled="!isEnabled">Send Test Email</el-button>

       </el-col>

       <div>
         <span class="text-muted">Configure: </span>
         <check-box v-model="emails.sendMail" :disabled="!isTowerCo() || isViewOnly()" no-form
           @change="fieldChanged(actionData, 'emails.sendMail')">
         Send E-mails
         <template #cue><field-cue :row="actionData" path="emails.sendMail" label="Send e-mails" layout="inline" /></template>
       </check-box>
     </div>


  </td>
  </tfoot>

</table>

<!-- XOL-526 (U-L): there is no third column for the provider (D10 ii) — say
     where its notices go, so a Tower Co managing recipients doesn't wonder
     why the provider isn't listed anywhere. -->
<p v-if="hasDistinctProvider()" class="text-muted">
  <small><i class="fa fa-info-circle" aria-hidden="true"></i> {{providerNoticeLine}}</small>
</p>
</el-row>


</section>

</template>


<script>

import RequestMixins from '@/mixins/RequestMixins'
import FieldCue from '@/components/requests/FieldCue'

export default {
  mixins: [RequestMixins],

  components: {
    FieldCue
  },

  props: {

    rowData: {
      type: Object,
      required: true
    },

    rtxInfo: {
      type: Object,
      required: true
    }

  },


  methods: {
    sendTest (prop = this.isTelco() ? 'telco' : 'tower') {

      var verify = {
        info: this.rtxInfo.info,
        from: {
          email: this.xolasClient().email,
          name: this.xolasClient().name,
          logo: this.xolasClient().logoPath
        },
        sendTo: []
      }

      var i = 0

      for (i = 0; i < this.emails[prop].length; i++) {
        if (this.emails[prop][i].email) {
          verify.sendTo.push(this.emails[prop][i].email)
        }
      }

      this.send(this, this.getEndpoint('mail/verify'), verify, 'Verification e-Mail', this.sent, this.notSent)
    },


    sent (response) {
      this.$message({message: 'e-mail sent', type: 'success'})
    },


    notSent (response) {
      this.$message({message: 'e-mail failed to send', type: 'error'})
      console.error(response)
    },


    // XOL-596: a recipient add / remove / sync marks its whole list changed
    // (`emails.tower` / `emails.telco`, an array whole at its own path) and
    // records the operation; the list is saved at the form's pause, with the Tower
    // Co's write or, for the telco OWNER's own list (XOL-535), the counterparty's.
    // If someone else changed the same list meanwhile, the operations are
    // re-applied onto theirs by e-mail and resubmitted once (R2.9). A new address
    // the API drops because it is not an enabled owner contact is absent from the
    // 200; RequestMixins warns and does not re-add it.
    addEmail (prop, email) {
      var cont = {}
      cont.sendUploadAlerts = true
      cont.sendApprovalAlerts = true
      cont.email = email

      this.newEmail = null
      this.newTelcoEmail = null

      if (prop === 'telco' && !this.isTowerCo() && !this.canEditTelcoRecipients()) return
      if (prop === 'tower' && !this.isTowerCo()) return

      this.emails[prop].push(this.clone(cont))
      this.recordListOp(this.actionData, 'emails.' + prop, { type: 'add', key: email, item: cont })
      this.fieldChanged(this.actionData, 'emails.' + prop)
    },


    deleteEmail (list, index) {
      var prop = (list === this.emails.telco) ? 'telco' : 'tower'
      var gone = list[index]

      list.splice(index, 1)

      if (!gone) return

      this.recordListOp(this.actionData, 'emails.' + prop, { type: 'remove', key: gone.email })
      this.fieldChanged(this.actionData, 'emails.' + prop)
    },


    // XOL-526/535 (U-L, §2.6.2): the telco column's org name, with the
    // established fallback for a malformed/partial actionData.
    telcoOrgName () {
      return (this.actionData.organisation && this.actionData.organisation.name) ? this.actionData.organisation.name : 'the telco'
    },


    // The sync buttons: add every org contact not listed yet. Each addition is a
    // recorded operation, like an Add.
    updateEmails (type, addMissing = false) {
      var list = this.emails[type]
      var before = list.map(function (e) { return e && e.email })

      this.updateEmailList(list,
      (type === 'tower'
      ? this.tower
      : this.telco),
      addMissing)

      var self = this
      var added = list.filter(function (e) { return e && before.indexOf(e.email) === -1 })

      added.forEach(function (e) {
        self.recordListOp(self.actionData, 'emails.' + type, { type: 'add', key: e.email, item: e })
      })

      if (added.length > 0) {
        this.fieldChanged(this.actionData, 'emails.' + type)
      }
    },


    updateTowerEmails (data) {
      this.tower = data
//      console.log('tower', this.tower)
    },


    updateTelcoEmails (data) {
      this.telco = data
//      console.log('telco', this.telco)
    },

    // XOL-526 (U-L): explains the fallback A7 now applies server-side to an
    // empty per-request list.
    emptyFallbackLine (prop) {
      var orgName = prop === 'telco' ? this.telcoOrgName() : this.towerCoName()

      return 'No one is listed, so upload notices go to ' + orgName + ' users who have Upload Alerts on in their User Profile.'
    }

  },

  computed: {

    // XOL-526 (U-L): D10(ii) — the provider is never a column here; its
    // people opt in on their own profile.
    providerNoticeLine: function () {
      return 'Upload notices also go to ' + this.providerLabel() +
        '. Its users choose whether to receive them with Upload Alerts on their own User Profile, so they are not listed here.'
    },

    // XOL-535 (S6, UX §2.6.2): drops the "you can add" sentence for a viewer
    // who can't add to the telco list (a view-only Telco, or a Telco on a
    // non-RTB type). For the Tower Co, `canEditTelcoRecipients()` reduces to
    // `canWriteStep()` (`isTowerCo() && !isViewOnly()`) — so this is the
    // fuller text for a writable Tower Co, same as today, but the shorter
    // text for a view-only one, which could not add to either column anyway.
    alertDescription: function () {
      return this.canEditTelcoRecipients()
        ? 'The default emails are defined by the system administrator. You can add individual emails here.'
        : 'The default emails are defined by the system administrator.'
    },

    isEnabled: function () {
      var enabled = false

      var prop = this.isTelco() ? 'telco' : 'tower'

      for (var i = 0; i < this.emails[prop].length; i++) {
        if (this.emails[prop][i]) {
          enabled = true
          break
        }
      }  // for

      return enabled
    }

  },


  data () {
    return {
      newEmail: null,
      newTelcoEmail: null,
      emails: this.rowData.emails,
      actionData: this.rowData,
      telco: [],
      tower: [],
      siteId: this.rowData ? this.rowData.site_id : null
    }

  },


  created () {
    // XOL-526 (C3): both fetches are cross-tenant reads (tenant.towerco) —
    // unguarded, they 403 for every caller that isn't the Tower Co or the
    // org being read. `showEmailSetup` (RequestWorkflow.vue) NARROWS who
    // even opens this popup — a provider never reaches it (D10 ii) — it
    // does not widen the caller set. The guard here is for the two callers
    // who already could open it: the Tower Co (always passes) and the Telco
    // owner, whose TOWER fetch was the actual C3 bug (it read the Tower Co's
    // contacts and 403'd every time).
    if (this.canReadOrgScoped(this.actionData.organisation_id)) {
      this.fetchData('/contacts/org/' + this.actionData.organisation_id + '/raw/true', this.updateTelcoEmails, 'Telco Contacts')
    }

    if (this.canReadOrgScoped(this.xolasClient().id)) {
      this.fetchData('/contacts/org/' + this.xolasClient().id + '/raw/true', this.updateTowerEmails, 'Tower Contacts')
    }
  },

}

</script>
